import * as React from "react";
import eventStatusLabel from "security-app/logic/eventStatusLabel";
const Status = ({ statusId }) => /* @__PURE__ */ React.createElement(React.Fragment, null, eventStatusLabel(statusId));
export default Status;
